class StopWatch {
  constructor($interval) {
    this.time = 0;
    this.formattedTime = "00 : 00 : 00";

    let loop = {};
    let offset;

    const delta = () => {
      const now = Date.now();
      const timePassed = now - offset;
      offset = now;
      return timePassed;
    };

    const timeFormatter = (timeInMs) => {
      const time = new Date(timeInMs);
      let minutes = time.getMinutes().toString();
      let seconds = time.getSeconds().toString();
      if (seconds.length < 2) {
        seconds = "0" + seconds;
      }
      if (minutes.length < 2) {
        minutes = "0" + minutes;
      }
      return `00 : ${minutes} : ${seconds}`;
    };
    const update = () => {
      this.time += delta();
      this.formattedTime = timeFormatter(this.time);
    };
    this.isOn = false;
    this.start = () => {
      this.clear();
      if (!this.isOn) {
        loop = $interval(update, 10);
        offset = Date.now();
        this.isOn = true;
      }
    };

    this.resume = () => {
      if (!this.isOn) {
        loop = $interval(update, 10);
        offset = Date.now();
        this.isOn = true;
      }
    };

    this.stop = () => {
      $interval.cancel(loop);
      this.isOn = false;
    };

    this.clear = () => {
      this.stop();
      this.time = 0;
      this.formattedTime = "00 : 00 : 00";
    };
  }
}

export default StopWatch;



// WEBPACK FOOTER //
// ./src/services/stopWatch/stopWatch.service.js